import { render, staticRenderFns } from "./merge.vue?vue&type=template&id=350be110&scoped=true"
import script from "./merge.vue?vue&type=script&lang=js"
export * from "./merge.vue?vue&type=script&lang=js"
import style0 from "./merge.vue?vue&type=style&index=0&id=350be110&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "350be110",
  null
  
)

export default component.exports